import { ISideMenuLang } from '../../../types/lang'

export const sideMenuLang: ISideMenuLang = {
	side_menu: {
		affiliate_title: 'Affiliate_ua',
		offer_scope_title: 'Tracking Cap_ua',
		offer_spend_title: 'Offer Spend_ua',
		offer_spend_report_title: 'Report Offer Spend_ua',
		offer_spend_report_by_account_title: 'By Account_ua',
		offer_spend_report_by_offer_title: 'By Offer_ua',
		offer_spend_report_by_offer_scope_title: 'By Offer Scope_ua',
		postback_send_title: 'Send Postback_ua',
		revenue_agency_title: 'Agency_ua',
		revenue_spend_title: 'Spend_ua',
		revenue_spend_report_by_account_title: 'ROI By User_ua',
		revenue_spend_report_by_team_title: 'ROI By Team_ua',
		account_title: 'Accounts_ua',
		role_title: 'Roles_ua',
		job_title: 'Jobs_ua',
		project_title: 'Projects_ua',
		login_title: 'Login_ua',
		logout_title: 'Logout_ua',
	}
}